'use client';

import { X } from 'lucide-react';
import { clsx } from 'clsx';

interface SearchClearButtonProps {
  onClick: () => void;
  /** Icon-Kantenlaenge in px — die Felder verwenden 14 bis 16. */
  size?: number;
  /** Positionierung der Aufrufstelle, z.B. absolute right-2 top-1/2. */
  className?: string;
}

/**
 * Das ✕ in den Suchfeldern. Bewusst ohne eigene Positionierung: die vier
 * Felder sitzen in unterschiedlichen Huellen, geteilt wird nur das Aussehen
 * des Knopfs selbst.
 *
 * tabIndex -1, weil der Knopf sonst zwischen Suchfeld und Filtern in der
 * Tab-Reihenfolge landet; per Tastatur leert Escape.
 */
export function SearchClearButton({
  onClick,
  size = 16,
  className,
}: SearchClearButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      tabIndex={-1}
      aria-label="Suche löschen"
      title="Suche löschen"
      className={clsx(
        'inline-flex items-center justify-center rounded p-1 text-gray-400 transition-colors hover:text-gray-600',
        className,
      )}
    >
      <X size={size} />
    </button>
  );
}
